import type { IOrganizationData } from '@carboncopyco/types';
import { isDesktop } from './validators';

export const convertToProtocolUrl = (url: string) => {
  let httpsPrefix = 'https://';
  const validPrefixes = [
    'https://',
    'http://',
    'https:/',
    'http:/',
    'https:',
    'http:',
  ];
  url = url.trim();
  const validPrefix = validPrefixes.find((prefix) => url.indexOf(prefix) === 0);

  if (isDesktop() && validPrefix === 'http://') {
    httpsPrefix = 'http://';
  }
  if (validPrefix) {
    url = url.replace(validPrefix, httpsPrefix);
  }
  if (!validPrefix) {
    url = `${httpsPrefix}${url}`;
  }
  return url;
};
export const parseURL = (protocolUrl: string) =>
  new URL(convertToProtocolUrl(protocolUrl));

export const validateUrl = (url: string) => {
  try {
    parseURL(url);
    return true;
  } catch (_err) {
    return false;
  }
};

export const isAllowedHost = (
  url: string,
  allowedHosts: IOrganizationData['allowedHosts']
) => {
  if (!allowedHosts.find((host) => url.includes(host) || host === '*')) {
    return false;
  }
  return true;
};

export const updateQueryString = (
  queryString: string,
  params: Record<string, string>
): string => {
  const queryStringParams = new URLSearchParams(queryString);
  Object.entries(params).forEach(([key, val]) => {
    queryStringParams.set(key, val);
  });

  return `?${queryStringParams.toString()}`;
};
